// src/admin/pages/OrderFailed.tsx
import React from 'react';
import { XCircle } from 'lucide-react';
import { Link } from 'react-router-dom';

export const OrderFailed = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-red-50">
      <div className="bg-white p-8 rounded-lg shadow-md text-center">
        <XCircle className="h-12 w-12 text-red-500 mx-auto" />
        <h2 className="mt-4 text-2xl font-semibold text-gray-800">Payment Failed</h2>
        <p className="mt-2 text-gray-600">There was an issue processing your payment. Please try again.</p>
        <Link to="/checkout" className="mt-6 inline-block bg-pink-500 text-white px-6 py-2 rounded-lg hover:bg-pink-600">
          Retry Payment
        </Link>
      </div>
    </div>
  );
};
